// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__n7ygh","logoContainer":"Navbar_logoContainer__XyjVx","logoImage":"Navbar_logoImage__-Q3w6","accountButton":"Navbar_accountButton__-Ce7E"};